import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'YOUR_SUPABASE_URL';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY';

console.log('🔧 Supabase Client Configuration:', {
  url: supabaseUrl,
  urlValid: supabaseUrl && supabaseUrl !== 'YOUR_SUPABASE_URL',
  keyExists: !!supabaseAnonKey,
  keyValid: supabaseAnonKey && supabaseAnonKey !== 'YOUR_SUPABASE_ANON_KEY',
  keyStart: supabaseAnonKey?.substring(0, 20)
});

if (!supabaseUrl || supabaseUrl === 'YOUR_SUPABASE_URL') {
  console.error('❌ SUPABASE_URL not configured!');
}

if (!supabaseAnonKey || supabaseAnonKey === 'YOUR_SUPABASE_ANON_KEY') {
  console.error('❌ SUPABASE_ANON_KEY not configured!');
}

// Custom fetch with longer timeout
const customFetch = (url, options = {}) => {
  return fetch(url, {
    ...options,
    signal: AbortSignal.timeout(30000), // 30 second timeout instead of default
  });
};

// Create client with custom options
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  global: {
    fetch: customFetch,
  },
  db: {
    schema: 'public'
  }
});

console.log('✅ Supabase client created with custom fetch');